import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from 'app/shared/shared.module';
import { MatMenuModule } from '@angular/material/menu';
import { MoveFolderComponent } from './components/move-folder/move-folder.component';
import { ReportSuccessDialogComponent } from './components/report-success-dialog/report-success-dialog.component';

// AoT requires an exported function for factories
const httpLoaderFactory = (http: HttpClient): any =>new TranslateHttpLoader(http,'../../../src/assets/i18n/en.json','.json');

const providers = [];

@NgModule({
  declarations: [
    AppComponent,
    MoveFolderComponent,
    ReportSuccessDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatMenuModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader:{
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps:[HttpClient]
      }
  }),
  SharedModule
  ],
  providers: providers,
  bootstrap: [AppComponent]
})

export class AppModule {
}

@NgModule({})
export class ReportBuilderSharedModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: providers
    };
  }
}
